import { ChartingStatus } from '@/types/appointments';

export const CHARTING_STATUS_LABELS: Record<ChartingStatus, string> = {
  [ChartingStatus.SESSION_COMPLETE]: 'Session Complete',
  [ChartingStatus.SESSION_INCOMPLETE]: 'Session Incomplete',
  [ChartingStatus.CHART_PENDING]: 'Chart Pending'
};

// Falls back to the boolean for responses that predate charting_status
export const resolveChartingStatus = (
  status: ChartingStatus | null | undefined,
  completed: boolean | null | undefined
): ChartingStatus => {
  if (status) return status;
  return completed ? ChartingStatus.SESSION_COMPLETE : ChartingStatus.CHART_PENDING;
};
